import {
  Button,
  Checkbox,
  FormControl,
  Grid,
  Input,
  InputAdornment,
  InputLabel,
  LinearProgress,
  ListItemText,
  MenuItem,
  Select,
  TextField,
  Typography,
  // InputAdornment,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import * as React from "react";
import Component from "src/shared/components/Component";
import CloseIcon from "@material-ui/icons/Close";
// import { Email } from "@material-ui/icons";
import Modal from "src/shared/components/Modal";
import PartialCleanCheck from "src/shared/components/PartialCleanCheck";
import withAxios from "src/shared/components/withAxios";
import { ICoach, ICoachData, ISchoolIdRequest } from "src/api/types";
import { withSchoolContext } from "../../../../DirectorPage";
import "src/features/home/pages/signUp-pages/style.css";
import EmailValidator from "email-validator";
import {
  ACTIVE_GROUP,
  // CLOSE_MODAL_BUTTON_LABEL,
  COACH_DEACTIVATION_CONFIRMATION,
  COACH_DEACTIVATION_CONFIRMATION_AD,
  COACH_DELETION_CONFIRMATION,
  COACH_DELETION_CONFIRMATION_AD,
  // COACH_DELETION_INSTRUCTIONS,
  // COACH_DELETION_INSTRUCTIONS_AD,
  // COACH_EDIT_CONFIRMATION,
  // COACH_EDIT_CONFIRMATION_AD,
  // COACH_NAME_PREFACE,
  // COACH_NAME_PREFACE_AD,
  COACH_TEXT_FIELD_LABEL,
  CREATE_COACH_BUTTON_LABEL,
  DELETE_COACH_BUTTON_LABEL,
  EDIT_COACH,
  // EDIT_AD,
  NEW_COACH,
  // SAME_NAME_WARNING,
  // SAME_NAME_WARNING_AD,
  // SIMILAR_NAME_WARNING,
  // SIMILAR_NAME_WARNING_AD,
  SPORT_SELECTION_LABEL,
  UPDATE_COACH_BUTTON_LABEL,
} from "./constants";
import { Info } from "@material-ui/icons";
import {
  Tooltip
} from "@material-ui/core";
import { styles } from "./styles";
import { IBaseProps, IEditCoachModalState, IProps } from "./types";
import { IUser } from "src/api/types";

export default withSchoolContext<IBaseProps>(
  withStyles(styles, { withTheme: true })(
    withAxios(
      class extends Component<IProps, IEditCoachModalState> {
        public readonly state = this.buildState({
          active: false,
          coachSports: [],
          deleteCoachName: "",
          name: "",
          isMeadSeason: false,
          particularCoachSportId:"",
          coachEmail: "",
          disableEditing:false,
          coachtype:"",
          userId:"",
        });

        // private warningCoachIndex: number | undefined = undefined;

        private readonly deleteCoachNameChange = this.stateInputEventHandler(
          (v) => ({ deleteCoachName: v })
        );

        private partialCleanCheck: PartialCleanCheck<IEditCoachModalState> =
          new PartialCleanCheck(this, ["active", "name", "coachSports", "coachEmail"]);

        private readonly handleNameChange = this.stateInputEventHandler(
          (v) => ({ name: v })
        );

        public componentDidMount = async () => {  
                  const res: any = await this.buildGet<IUser>(this, "user")()
                  this.setState({userId: res?.id});
                  const hhheadcoch =  await this.buildPost<{userId:any, schoolId:any}, any>(
                    this,"/coaches/getHeadCoach")({
                    userId: res?.id,
                    schoolId: this.props.school.id,
                     });
                  console.log("meadseson res:::::", hhheadcoch, hhheadcoch,this.props)
                if( hhheadcoch?.data?.type === "head" && hhheadcoch?.data !== null){
                  this.setState({ isMeadSeason: true,
                    particularCoachSportId: hhheadcoch?.data?.sportId
                  })       
                }          
                }
                public componentDidUpdate = async (prevProps: IProps) => {
                  const { open: prevOpen, coach: prevCoach } = prevProps;
                  const { open, coach} = this.props;
                
                  if (!prevOpen && open) {
                    this.setState({
                      coachSports: [],
                      deleteVisible: undefined,
                      name: "",
                      coachEmail: "",
                    });
                    this.setState({name: "",  disableEditing: false})
                  }
                
                  if (
                    (!prevOpen && open && !!coach) ||
                    (!!coach && !!prevCoach && coach.id !== prevCoach.id) ||
                    (!!coach && !prevCoach)
                  ) {
                    this.setState((_) => {
                      const newState = {
                        active: coach.active,
                        coachSports: coach.sports.map((sport) => sport.name),
                        name: coach.name,
                        coachEmail: coach?.user?.email ?? "",
                        coachtype: coach?.coachType
                      };
                      this.partialCleanCheck.setOldFormData(newState);
                      return newState;
                    });
                  }
                };
                

        public render() {
          const { name, coachSports, postingCoach, deleteVisible, particularCoachSportId,
            isMeadSeason, coachEmail , disableEditing } = this.state;
          const { coach, open, sports, classes,midSeasonCheckin } = this.props;
          return (
            <Modal
              open={open}
              closeModal={this.props.closeModal}
              className={classes.coachModal}
            
            >
              <Grid
                container={true}
                style={{ height: "100%" }}
                direction="column"
                justifyContent="space-between"
              >
                <Grid className={classes.inputs}>
                  <div className="input-edit-corner">
                  <Typography
                  variant="h3"
                  style={this.props?.schoolData?.ismidseason ? { fontSize: "2rem" } : {}}

                  >
                    {coach ? 
                   <>{this.props?.schoolData?.isAdSurvey === true ? "Edit AD" : EDIT_COACH}</>  : 
                   <>{this.props?.schoolData?.isAdSurvey === true ? "New AD" :this.props?.schoolData?.ismidseason ? "NEW SUB-VARSITY COACH":NEW_COACH }</>}
                  </Typography>
                  <Button variant="contained" className="btn-label-content" 
                  onClick={()=>{this.props.closeModal();
                    this.setState({coachEmail: ""});
                    this.setState({ disableEditing: false
                    });
                  }
                  }>
                  <CloseIcon />
                  </Button>
                  </div>
                  <Grid
                    container={true}
                    direction="column"
                    justifyContent="flex-start"
                  >
                    
                    {!!!deleteVisible && (
                      <React.Fragment >
                        <TextField className="name-coach"
                          label={COACH_TEXT_FIELD_LABEL}
                          value={name}
                          onChange={this.handleNameChange}
                          disabled = {disableEditing ? true : false}
                        />
                        {/* {this.renderNameWarning()} */}
                        {console.log("coach email", coach)}

                        {midSeasonCheckin && (
  (
    // CASE 1: New Sub-Varsity Coach
    this.props?.editCochaModalStatus === "NewCoach" ||

    // CASE 2: Existing coach with email
    Boolean(coach?.user?.email)
  ) && (
    <TextField
      label="Coach Email"
      className="select-coach text-coach-bottom"
      value={coachEmail}
      disabled={Boolean(coach?.user?.email)} // existing → locked
      onChange={this.handleDirectorEmailChange}
       // InputProps={{
                          //   startAdornment: (
                          //     <InputAdornment position="start">
                          //       <Email />
                          //     </InputAdornment>
                          //   ),
                          // }}
                         InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <Tooltip
              enterTouchDelay={0}
              leaveTouchDelay={4000}
              placement="top"
              title={
                <Typography style={{ fontSize: "14px" }}>
                  {"Sub-varsity access is optional. Add their email to give them access, otherwise you’ll need to share data with them manually."}
                </Typography>
              }
            >
              <Info
                style={{ fontSize: 20, color: "#6b7280", cursor: "pointer" }}
              />
            </Tooltip>
          </InputAdornment>
        ),
      }}                           
    />
  )
)}

        {/* {console.log("sportssports", sports)} */}
                        <FormControl>
                          <InputLabel
                          className="select-input-coach" htmlFor="select-multiple-checkbox">
                            {SPORT_SELECTION_LABEL}
                          </InputLabel>
                         <Select
  className="select-coach"
  multiple={true}
  value={coachSports}
  onChange={this.handleSportsChange}
  input={<Input id="select-multiple-checkbox" />}
  renderValue={this.renderSelectValues}
  disabled={!!this.props.coach && this.props.schoolData?.ismidseason === true}
>
  {(
    isMeadSeason
      ? sports.filter((sport) => particularCoachSportId.includes(sport.id)) 
      : this.props?.schoolData?.isAdSurvey
      ? sports.filter((sport) => [72, 74, 73, 68].includes(sport.id)) // Show only these 4
      : sports.filter((sport) => ![72, 74, 73, 68].includes(sport.id)) // Show all EXCEPT these 4
  ).map((sport) => (
    <MenuItem key={sport.id} value={sport.name}>
      <Checkbox checked={coachSports.indexOf(sport.name) > -1} />
      <ListItemText primary={sport.name} />
    </MenuItem>
  ))}

</Select>
                        </FormControl>
                        {!!coach && this.renderToggleActive()}
                      </React.Fragment>
                    )}
                    {!!coach && this.renderDeleteCoach(coach)}
                  </Grid>
                </Grid>

                {postingCoach && <LinearProgress />}
                <Grid className="btn-new-coach" container={true} justifyContent="space-between">
                
                 {!deleteVisible &&
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={coach ? this.updateCoach : this.addCoach}
                    disabled={
                      !this.canSubmit() || this.partialCleanCheck.isClean()
                    }
                  >
                    {console.log(this.props?.schoolData?.isAdSurvey,"this.props?.schoolData?.isAdSurvey")}
                    {coach 
                      ?    <>{this.props?.schoolData?.isAdSurvey === true ? "CHANGE AD" : UPDATE_COACH_BUTTON_LABEL}</> 
                      :  <>{this.props?.schoolData?.isAdSurvey === true ? "ADD NEW AD" : this.props?.schoolData?.ismidseason? "ADD NEW SUB-VARSITY COACH": CREATE_COACH_BUTTON_LABEL} </> 
                    }
                </Button>}
                </Grid>
              </Grid>
            </Modal>
          );
        }

        private readonly toggleActive = () => {
          this.setState((oldState) => ({ active: !oldState.active }));
        };

        private renderToggleActive() {
          const { classes } = this.props;
          const { active } = this.state;
          return (
            <div>
              <span>{ACTIVE_GROUP}</span>
              <Checkbox checked={active} onChange={this.toggleActive} />
              {!active && (
                <span className={classes.lightWarning}>
                  {this.props?.schoolData?.isAdSurvey === true ? COACH_DEACTIVATION_CONFIRMATION_AD : COACH_DEACTIVATION_CONFIRMATION}
                </span>
              )}
            </div>
          );
        }

        // private readonly changeEditCoach = () => {
        //   if (this.warningCoachIndex !== undefined) {
        //     this.props.changeEditCoach(
        //       this.props.coaches[this.warningCoachIndex]
        //     );
        //   }
        // };

        private handleDirectorEmailChange = async (
          e: React.ChangeEvent<HTMLInputElement>
        ) => {
          const coachEmail = e.target.value;
        
          // Update state first
          this.setState({ coachEmail });
        if(coachEmail){
          try {
            // API Callcurl --location 'http://localhost:3001/api/school/getuser/eramitec9@gmail.com'
            const res: any = await this.buildGet<IUser>(this, `/school/getuser/${coachEmail}`)();
            console.log("/school/getuser/", res);
            if(res?.user?.firstName || res?.user?.lastName){
            this.setState({ name: res?.user?.firstName + " " + 
              res?.user?.lastName, disableEditing: true
            });
          }else{
            this.setState({ disableEditing: false
            });
          }
          } catch (error) {
            console.error("Error fetching user:", error);
          }
        }else{
          this.setState({name: "",  disableEditing: false})
        }
        };
        
        // private renderNameWarning() {
        //   const { classes } = this.props;
        //   const { name } = this.state;
        //   const { coaches, coach } = this.props;
        //   const warning = (() => {
        //     const findCoachSameIndex = coaches.findIndex(
        //       (c) =>
        //         c.name === name && (coach === undefined || c.id !== coach.id)
        //     );
        //     if (findCoachSameIndex !== -1) {
        //       this.warningCoachIndex = findCoachSameIndex;
        //       return (
        //         <span className={classes.warning}>
        //         {this.props?.schoolData?.isAdSurvey === true ? SAME_NAME_WARNING_AD : SAME_NAME_WARNING}
        //         </span>
        //       );
        //     }
        //     const findCoachSimilarIndex = coaches.findIndex(
        //       (c) =>
        //         c.name.toLowerCase() === name.toLowerCase() &&
        //         (coach === undefined || c.id !== coach.id)
        //     );
        //     if (findCoachSimilarIndex !== -1) {
        //       this.warningCoachIndex = findCoachSimilarIndex;
        //       return (
        //         <span className={classes.lightWarning}>
        //           {this.props?.schoolData?.isAdSurvey === true ? SIMILAR_NAME_WARNING_AD : SIMILAR_NAME_WARNING}
        //         </span>
        //       );
        //     }
        //     return null;
        //   })();
        //   if (warning !== null) {
        //     return (
        //       <div>
        //         {warning}
        //         <div>
        //           <span>
        //             {this.props?.schoolData?.isAdSurvey === true ? COACH_EDIT_CONFIRMATION_AD : COACH_EDIT_CONFIRMATION}
        //           </span>
        //           <Button
        //             variant="contained"
        //             color="primary"
        //             onClick={this.changeEditCoach}
        //           >
        //             {this.props?.schoolData?.isAdSurvey === true ? EDIT_AD : EDIT_COACH}
        //           </Button>
        //         </div>
        //       </div>
        //     );
        //   }
        //   return null;
        // }

        private readonly toggleDelete = () =>
          this.setState((oldState) => ({
            deleteCoachName: "",
            deleteVisible: oldState.deleteVisible ? undefined : true,
          }));

        private renderDeleteCoach(coach: ICoach) {
          const { deleteVisible, deleteCoachName } = this.state;
          console.log("trim", coach.name.replace(/\s/g, ""), deleteCoachName.replace(/\s/g, "") )
          const isDeleteEnabled =
  deleteCoachName.replace(/\s+/g, "").toLowerCase() === "delete";

          return (
            <div >
                <div >
                {!deleteVisible
                
             ? <div><Button onClick={this.toggleDelete}>
             <div>{DELETE_COACH_BUTTON_LABEL}</div>
         </Button></div>:

         <div  className="coach-deletion-confirm">
          <div className="coach-deletion-head">
          {this.props?.schoolData?.isAdSurvey === true ? COACH_DELETION_CONFIRMATION_AD : COACH_DELETION_CONFIRMATION}
          </div>
            {/* <div className="closedive"><Button className="closedelete-icon"  onClick={this.toggleDelete}>
               <div>  <CloseIcon /></div>
                  
              </Button></div> */}
              </div>
              }
              </div>
              {!!deleteVisible && (
                <div>
                  
                  <div style={{ marginTop: 8 }}>
  Type "DELETE" to confirm deletion.
  <Tooltip
    enterTouchDelay={0}
    leaveTouchDelay={4000}
    placement="right"
    title={
      <Typography style={{ fontSize: "14px" }}>
        If you want to delete the user entirely, go to the Admin tab and delete them there. Deleting here only removes the data associated with this coach.
      </Typography>
    }
  >
    <Info style={{ marginLeft: 6, fontSize: 18, cursor: "pointer" }} />
  </Tooltip>
</div>


                  {/* <div>
                    {this.props?.schoolData?.isAdSurvey === true ? COACH_NAME_PREFACE_AD : COACH_NAME_PREFACE}
                     {coach.name}
                  </div> */}
                  <TextField
                    value={deleteCoachName}
                    onChange={this.deleteCoachNameChange}
                  />
                  <Grid container={true} justifyContent="space-between">
                    {/* <Button onClick={this.toggleDelete}>
                      {!deleteVisible
                        ? DELETE_COACH_BUTTON_LABEL
                        : CLOSE_MODAL_BUTTON_LABEL}
                    </Button> */}
                    <Button onClick={this.toggleDelete}>
                      Cancel
                    </Button>
                  {/* {coach.name.replace(/\s/g, "").toLowerCase() !== deleteCoachName.replace(/\s/g, "").toLowerCase()?
                  <Button
                   disabled={true}
                  variant="contained"
                  color="secondary"
                >
                  Delete
                </Button>:
                    <Button
                      // disabled={coach.name !== deleteCoachName}
                      onClick={this.deleteCoach}
                      variant="contained"
                      color="secondary"
                    >
                      Delete
                    </Button>
        } */}

        {!isDeleteEnabled ? (
  <Button disabled={true} variant="contained" color="secondary">
    Delete
  </Button>
) : (
  <Button
    onClick={this.deleteCoach}
    variant="contained"
    color="secondary"
  >
    Delete
  </Button>
)}

                  </Grid>
                </div>
              )}
            </div>
          );
        }

       private deleteCoach = () =>
  void this.runCancellableStatefulAsync(
    this,
    {},
    {},
    async () => {
      console.log("🔍 DELETE COACH CALLED");

      const { coach } = this.props;
      const { deleteCoachName } = this.state;

      console.log("➡️ Props.coach:", coach);
      console.log("➡️ State.deleteCoachName:", deleteCoachName);

      if (coach === undefined) {
        console.error("❌ Coach is undefined");
        throw new Error("Coach should be defined");
      }

      // if (coach.name !== deleteCoachName) {
      //   console.error(
      //     `❌ Name mismatch: coach.name='${coach.name}' deleteCoachName='${deleteCoachName}'`
      //   );
      //   throw new Error("Coach name mismatch");
      // }

      console.log("✔️ Validation passed. Deleting coach with ID:", coach.id);

      const payload = { schoolId: this.props.school.id };
      console.log("➡️ API Request Payload:", payload);

      const endpoint = `coach/${coach.id}`;
      console.log("➡️ DELETE Endpoint:", endpoint);

      try {
        await this.buildDeleteWithParams<void, ISchoolIdRequest>(this, endpoint)(payload);
        console.log("✔️ Coach deleted successfully");
      } catch (err) {
        console.error("❌ API Delete Error:", err);
        throw err;
      }

      console.log("➡️ Closing modal");
      this.props.closeModal();

      console.log("➡️ Reloading coaches");
      this.props.loadCoaches();
    },
    (error) => {
      const { coach } = this.props;

      console.error("❌ DELETE FAILED", error);

      if (coach === undefined) {
        console.error("❌ Coach undefined inside error block");
        throw new Error("Coach should be defined");
      }

      window.alert(`Failed to delete coach: ${coach.name}`);
    }
  );

        private readonly handleSportsChange = (e: React.ChangeEvent<any>) =>
          this.setState({ coachSports: e.target.value });

        private readonly renderSelectValues = (selected: string[]) =>
          selected.join(", ");

        private readonly addCoach: () => undefined = () =>
          void this.runCancellableStatefulAsync(
            this,
            {
              postingCoach: true,
            },
            {
              postingCoach: undefined,
            },
            async () => {
              const { active, name, coachSports, coachEmail } = this.state;
              const coachSportIds = coachSports
  .map((coachSport) => {
    const sport = this.props.sports.find((s) => s.name === coachSport);
    return sport ? sport.id : -1;
  })
  .filter((sportId) => sportId !== -1); // Remove invalid sports

let foundMatch = false; // ✅ Track if any condition is met
for (const item of this.props.Allsport) {
  const hasSport = item.sportId.some((sport: any) => coachSportIds.includes(sport));

  if (item.sportId.length === 0 && item.email === coachEmail) {
    alert("This email already exists");
    foundMatch = true; 
    break;
  } else if (hasSport && item.email === coachEmail) { 
    // ✅ Convert sport IDs to sport names
    const matchedSports = item.sportId
      .filter((sport: any) => coachSportIds.includes(sport)) // Only keep matched sports
      .map((sportId: any) => {
        const sport = this.props.sports.find((s) => s.id === sportId);
        return sport ? sport.name : "Unknown"; // Convert ID to Name
      });

    console.log("Checking:", item.email, "Sports:", item.sportId, hasSport);
    alert(`This email already headcoach in these sports first unselect these sports: ${matchedSports.join(", ")}`);
    foundMatch = true; 
    break;
  }
}

// ✅ Only call API if no match was found
if (!foundMatch) {
              await this.buildPost<ICoachData, void>(
                this,
                "coach"
              )({
                active,
                name,
                schoolId: this.props.school.id,
                email: coachEmail.trim().toLowerCase(),
                invited_role: "coach",
                user_id: this.state.userId,
                // Since we can only store the name of the sport in the state, we have to map them back onto the id
                sports: coachSports
                  .map((coachSport) => {
                    const sport = this.props.sports.find(
                      (s) => s.name === coachSport
                    );
                    return sport === undefined ? -1 : sport.id;
                  })
                  .filter((sportId) => sportId !== -1),
              } as any);
              this.props.closeModal();
              this.props.loadCoaches();
            }
            },
            () => {
              this.setState({ postingCoach: undefined });
              window.alert("Failed to post coach");
              // Do nothing
            }
          );

          private readonly updateCoach: () => undefined = () =>
            void this.runCancellableStatefulAsync(
              this,
              {
                postingCoach: true,
              },
              {
                postingCoach: undefined,
              },
              async () => {
                const { active, name, coachSports, coachEmail } = this.state;
                const { coach } = this.props;
                
                const coachSportIds = coachSports
                  .map((coachSport) => {
                    const sport = this.props.sports.find((s) => s.name === coachSport);
                    return sport ? sport.id : -1;
                  })
                  .filter((sportId) => sportId !== -1); // Remove invalid sports
          
                let foundMatch = false; // ✅ Track if any condition is met
                for (const item of this.props.Allsport) {
                  const hasSport = item.sportId.some((sport: any) => coachSportIds.includes(sport));
          
                  if (item.sportId.length === 0 && item.email === coachEmail) {
                    alert("This email already exists");
                    foundMatch = true;
                    break;
                  } else if (hasSport && item.email === coachEmail) {
                    // ✅ Convert sport IDs to sport names
                    const matchedSports = item.sportId
                      .filter((sport: any) => coachSportIds.includes(sport)) // Only keep matched sports
                      .map((sportId: any) => {
                        const sport = this.props.sports.find((s) => s.id === sportId);
                        return sport ? sport.name : "Unknown"; // Convert ID to Name
                      });
          
                    console.log("Checking:", item.email, "Sports:", item.sportId, hasSport);
                    alert(`This email is already a head coach in these sports. First unselect these sports: ${matchedSports.join(", ")}`);
                    foundMatch = true;
                    break;
                  }
                }
          
                // ✅ Only call API if no match was found
                if (!foundMatch) {
                  if (coach === undefined) {
                    throw new Error("unreachable");
                  }
                  await this.buildPut<ICoachData, void>(
                    this,
                    `coach/${coach.id}`
                  )({
                    active,
                    name,
                    schoolId: this.props.school.id,
                    email: coachEmail.trim().toLowerCase(),
                                    // Since we can only store the name of the sport in the state, we have to map them back onto the id
                    sports: coachSports
                      .map((coachSport) => {
                        const sport = this.props.sports.find(
                          (s) => s.name === coachSport
                        );                      
                        return sport === undefined ? -1 : sport.id;
                      })
                      .filter((sportId) => sportId !== -1),
                  } as any);
                  this.props.closeModal();
                  this.props.loadCoaches();
                }
              },
              () => {
                this.setState({ postingCoach: undefined });
                window.alert("Failed to update coach");
                // Do nothing
              }
            );
          
          private readonly canSubmit = () => {
            const coachEmail = this.state.coachEmail?.trim() || "";
            const isEmailProvided = coachEmail.length > 0;
            const isEmailValid = !isEmailProvided || EmailValidator.validate(coachEmail);
          
            return Boolean(this.state.name) && this.state.coachSports.length !== 0 && isEmailValid;
          };
          
          
          
      }
    )
  )
);



// WEBPACK FOOTER //
// ./src/features/director/pages/dashboard/components/edit-coach-modal/EditCoachModal.tsx